"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _Checkbox = _interopRequireDefault(require("./Checkbox"));
var _ButtonBase = _interopRequireDefault(require("@mui/material/ButtonBase"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const CheckboxListItem = props => {
  const {
    checked = false,
    label = '',
    name = '',
    disabled = false,
    labelPlacement = 'end',
    type = '',
    // CheckboxListItem
    checkboxType = 'light',
    disableRipple = false,
    className = ''
  } = props;
  const CheckboxListItem = (0, _styles.styled)(_material.FormControlLabel)(() => ({
    width: '100%',
    margin: 0,
    borderBottom: '1px solid #EAEAEF',
    justifyContent: labelPlacement === 'end' ? '' : 'space-between',
    '&.Mui-disabled': {
      opacity: 0.2
    },
    '.MuiFormControlLabel': {
      width: labelPlacement === 'end' ? '100%' : 100,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      display: '-webkit-box',
      'WebkitBoxOrient': 'vertical',
      'WebkitLineClamp': '2'
    }
  }));
  const getStyledCheckboxForm = (0, _react.useCallback)(() => {
    switch (type) {
      case 'CheckboxListItem':
        return CheckboxListItem;
      default:
        return _material.FormControlLabel;
    }
  }, [type, CheckboxListItem]);
  const StyledFormControlLabel = p => {
    const StyledFormControlLabel = getStyledCheckboxForm();
    return /*#__PURE__*/_react.default.createElement(StyledFormControlLabel, _extends({
      control: /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        type: checkboxType,
        disabled: p.disabled || false
      })
    }, p));
  };
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_ButtonBase.default, {
    disabled: disabled,
    disableRipple: disableRipple,
    className: className
  }, /*#__PURE__*/_react.default.createElement(StyledFormControlLabel, {
    checked: checked,
    name: name,
    labelPlacement: labelPlacement,
    label: label,
    disabled: disabled
  })), [checked, labelPlacement, label, disabled, name, disableRipple]);
};
var _default = exports.default = CheckboxListItem;